/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssignIndividualPermissionRequestDto } from '../models';
// @ts-ignore
import type { BulkUpdateRolePermissionsRequestDto } from '../models';
// @ts-ignore
import type { BulkUpdateRolePermissionsResponseDto } from '../models';
// @ts-ignore
import type { InlineObject1Dto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { SuccessMessageDto } from '../models';
// @ts-ignore
import type { UserPermissionsResponseDto } from '../models';
/**
 * RestUserPermissionsApi - axios parameter creator
 * @export
 */
export const RestUserPermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Przypisuje uprawnienie bezpośrednio do użytkownika (poza rolami)
         * @summary Dodaj uprawnienie indywidualne do użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {AssignIndividualPermissionRequestDto} assignIndividualPermissionRequestDto Przypisanie uprawnienia indywidualnego do użytkownika
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIndividualPermissionToUser: async (userId: string, assignIndividualPermissionRequestDto: AssignIndividualPermissionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addIndividualPermissionToUser', 'userId', userId)
            // verify required parameter 'assignIndividualPermissionRequestDto' is not null or undefined
            assertParamExists('addIndividualPermissionToUser', 'assignIndividualPermissionRequestDto', assignIndividualPermissionRequestDto)
            const localVarPath = `/api/v1/users-management/{userId}/permissions/individual`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignIndividualPermissionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje statusy wielu uprawnień wynikających z ról jednocześnie. Każde uprawnienie może być aktywowane lub dezaktywowane per rola. Pozwala na precyzyjne zarządzanie uprawnieniami gdy użytkownik ma wiele ról. 
         * @summary Bulk update uprawnień z ról dla użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {BulkUpdateRolePermissionsRequestDto} bulkUpdateRolePermissionsRequestDto Bulk update statusu uprawnień z ról
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateUserRolePermissions: async (userId: string, bulkUpdateRolePermissionsRequestDto: BulkUpdateRolePermissionsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('bulkUpdateUserRolePermissions', 'userId', userId)
            // verify required parameter 'bulkUpdateRolePermissionsRequestDto' is not null or undefined
            assertParamExists('bulkUpdateUserRolePermissions', 'bulkUpdateRolePermissionsRequestDto', bulkUpdateRolePermissionsRequestDto)
            const localVarPath = `/api/v1/users-management/{userId}/permissions/from-roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateRolePermissionsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zwraca uprawnienia użytkownika z dwóch źródeł: 1. Uprawnienia wynikające z ról (z możliwością dezaktywacji) 2. Uprawnienia indywidualne (bezpośrednio przypisane) 
         * @summary Pobierz wszystkie uprawnienia użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissions: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserPermissions', 'userId', userId)
            const localVarPath = `/api/v1/users-management/{userId}/permissions`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Usuń uprawnienie indywidualne od użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {number} permissionId ID uprawnienia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeIndividualPermissionFromUser: async (userId: string, permissionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeIndividualPermissionFromUser', 'userId', userId)
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('removeIndividualPermissionFromUser', 'permissionId', permissionId)
            const localVarPath = `/api/v1/users-management/{userId}/permissions/individual/{permissionId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"permissionId"}}`, encodeURIComponent(String(permissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestUserPermissionsApi - functional programming interface
 * @export
 */
export const RestUserPermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestUserPermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Przypisuje uprawnienie bezpośrednio do użytkownika (poza rolami)
         * @summary Dodaj uprawnienie indywidualne do użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {AssignIndividualPermissionRequestDto} assignIndividualPermissionRequestDto Przypisanie uprawnienia indywidualnego do użytkownika
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addIndividualPermissionToUser(userId: string, assignIndividualPermissionRequestDto: AssignIndividualPermissionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addIndividualPermissionToUser(userId, assignIndividualPermissionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserPermissionsApi.addIndividualPermissionToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje statusy wielu uprawnień wynikających z ról jednocześnie. Każde uprawnienie może być aktywowane lub dezaktywowane per rola. Pozwala na precyzyjne zarządzanie uprawnieniami gdy użytkownik ma wiele ról. 
         * @summary Bulk update uprawnień z ról dla użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {BulkUpdateRolePermissionsRequestDto} bulkUpdateRolePermissionsRequestDto Bulk update statusu uprawnień z ról
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateUserRolePermissions(userId: string, bulkUpdateRolePermissionsRequestDto: BulkUpdateRolePermissionsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUpdateRolePermissionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateUserRolePermissions(userId, bulkUpdateRolePermissionsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserPermissionsApi.bulkUpdateUserRolePermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zwraca uprawnienia użytkownika z dwóch źródeł: 1. Uprawnienia wynikające z ról (z możliwością dezaktywacji) 2. Uprawnienia indywidualne (bezpośrednio przypisane) 
         * @summary Pobierz wszystkie uprawnienia użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPermissions(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPermissionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPermissions(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserPermissionsApi.getUserPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Usuń uprawnienie indywidualne od użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {number} permissionId ID uprawnienia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeIndividualPermissionFromUser(userId: string, permissionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeIndividualPermissionFromUser(userId, permissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserPermissionsApi.removeIndividualPermissionFromUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestUserPermissionsApi - factory interface
 * @export
 */
export const RestUserPermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestUserPermissionsApiFp(configuration)
    return {
        /**
         * Przypisuje uprawnienie bezpośrednio do użytkownika (poza rolami)
         * @summary Dodaj uprawnienie indywidualne do użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {AssignIndividualPermissionRequestDto} assignIndividualPermissionRequestDto Przypisanie uprawnienia indywidualnego do użytkownika
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIndividualPermissionToUser(userId: string, assignIndividualPermissionRequestDto: AssignIndividualPermissionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMessageDto> {
            return localVarFp.addIndividualPermissionToUser(userId, assignIndividualPermissionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje statusy wielu uprawnień wynikających z ról jednocześnie. Każde uprawnienie może być aktywowane lub dezaktywowane per rola. Pozwala na precyzyjne zarządzanie uprawnieniami gdy użytkownik ma wiele ról. 
         * @summary Bulk update uprawnień z ról dla użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {BulkUpdateRolePermissionsRequestDto} bulkUpdateRolePermissionsRequestDto Bulk update statusu uprawnień z ról
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateUserRolePermissions(userId: string, bulkUpdateRolePermissionsRequestDto: BulkUpdateRolePermissionsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<BulkUpdateRolePermissionsResponseDto> {
            return localVarFp.bulkUpdateUserRolePermissions(userId, bulkUpdateRolePermissionsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Zwraca uprawnienia użytkownika z dwóch źródeł: 1. Uprawnienia wynikające z ról (z możliwością dezaktywacji) 2. Uprawnienia indywidualne (bezpośrednio przypisane) 
         * @summary Pobierz wszystkie uprawnienia użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissions(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserPermissionsResponseDto> {
            return localVarFp.getUserPermissions(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Usuń uprawnienie indywidualne od użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {number} permissionId ID uprawnienia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeIndividualPermissionFromUser(userId: string, permissionId: number, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMessageDto> {
            return localVarFp.removeIndividualPermissionFromUser(userId, permissionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestUserPermissionsApi - interface
 * @export
 * @interface RestUserPermissionsApi
 */
export interface RestUserPermissionsApiInterface {
    /**
     * Przypisuje uprawnienie bezpośrednio do użytkownika (poza rolami)
     * @summary Dodaj uprawnienie indywidualne do użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {AssignIndividualPermissionRequestDto} assignIndividualPermissionRequestDto Przypisanie uprawnienia indywidualnego do użytkownika
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserPermissionsApiInterface
     */
    addIndividualPermissionToUser(userId: string, assignIndividualPermissionRequestDto: AssignIndividualPermissionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMessageDto>;

    /**
     * Aktualizuje statusy wielu uprawnień wynikających z ról jednocześnie. Każde uprawnienie może być aktywowane lub dezaktywowane per rola. Pozwala na precyzyjne zarządzanie uprawnieniami gdy użytkownik ma wiele ról. 
     * @summary Bulk update uprawnień z ról dla użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {BulkUpdateRolePermissionsRequestDto} bulkUpdateRolePermissionsRequestDto Bulk update statusu uprawnień z ról
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserPermissionsApiInterface
     */
    bulkUpdateUserRolePermissions(userId: string, bulkUpdateRolePermissionsRequestDto: BulkUpdateRolePermissionsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<BulkUpdateRolePermissionsResponseDto>;

    /**
     * Zwraca uprawnienia użytkownika z dwóch źródeł: 1. Uprawnienia wynikające z ról (z możliwością dezaktywacji) 2. Uprawnienia indywidualne (bezpośrednio przypisane) 
     * @summary Pobierz wszystkie uprawnienia użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserPermissionsApiInterface
     */
    getUserPermissions(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserPermissionsResponseDto>;

    /**
     * 
     * @summary Usuń uprawnienie indywidualne od użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {number} permissionId ID uprawnienia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserPermissionsApiInterface
     */
    removeIndividualPermissionFromUser(userId: string, permissionId: number, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMessageDto>;

}

/**
 * RestUserPermissionsApi - object-oriented interface
 * @export
 * @class RestUserPermissionsApi
 * @extends {BaseAPI}
 */
export class RestUserPermissionsApi extends BaseAPI implements RestUserPermissionsApiInterface {
    /**
     * Przypisuje uprawnienie bezpośrednio do użytkownika (poza rolami)
     * @summary Dodaj uprawnienie indywidualne do użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {AssignIndividualPermissionRequestDto} assignIndividualPermissionRequestDto Przypisanie uprawnienia indywidualnego do użytkownika
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserPermissionsApi
     */
    public addIndividualPermissionToUser(userId: string, assignIndividualPermissionRequestDto: AssignIndividualPermissionRequestDto, options?: RawAxiosRequestConfig) {
        return RestUserPermissionsApiFp(this.configuration).addIndividualPermissionToUser(userId, assignIndividualPermissionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje statusy wielu uprawnień wynikających z ról jednocześnie. Każde uprawnienie może być aktywowane lub dezaktywowane per rola. Pozwala na precyzyjne zarządzanie uprawnieniami gdy użytkownik ma wiele ról. 
     * @summary Bulk update uprawnień z ról dla użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {BulkUpdateRolePermissionsRequestDto} bulkUpdateRolePermissionsRequestDto Bulk update statusu uprawnień z ról
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserPermissionsApi
     */
    public bulkUpdateUserRolePermissions(userId: string, bulkUpdateRolePermissionsRequestDto: BulkUpdateRolePermissionsRequestDto, options?: RawAxiosRequestConfig) {
        return RestUserPermissionsApiFp(this.configuration).bulkUpdateUserRolePermissions(userId, bulkUpdateRolePermissionsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zwraca uprawnienia użytkownika z dwóch źródeł: 1. Uprawnienia wynikające z ról (z możliwością dezaktywacji) 2. Uprawnienia indywidualne (bezpośrednio przypisane) 
     * @summary Pobierz wszystkie uprawnienia użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserPermissionsApi
     */
    public getUserPermissions(userId: string, options?: RawAxiosRequestConfig) {
        return RestUserPermissionsApiFp(this.configuration).getUserPermissions(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Usuń uprawnienie indywidualne od użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {number} permissionId ID uprawnienia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserPermissionsApi
     */
    public removeIndividualPermissionFromUser(userId: string, permissionId: number, options?: RawAxiosRequestConfig) {
        return RestUserPermissionsApiFp(this.configuration).removeIndividualPermissionFromUser(userId, permissionId, options).then((request) => request(this.axios, this.basePath));
    }
}

